<template>
  <router-view />
  <BaseNotifications></BaseNotifications>
</template>

<script setup lang="tsx">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { routeNames } from "@/routes";
import LogoConnect from "@/components/LogoConnect.vue";

const route = useRoute();
const appSettingsStore = useAppSettingsStore();
const { setNavigationItems, setApplicationTitleComponent, setSuiteLogoComponent } = useAppNav();

const SmallComponent = () => <div class="">{appSettingsStore.pageTitleBase}</div>;
setApplicationTitleComponent(SmallComponent);

const connectUrl = import.meta.env.VITE_CONNECT_URL;

if (connectUrl) {
  setSuiteLogoComponent(() => (
    <a
      class="flex items-center ml-6 pl-3 pr-3 rounded-l-full bg-neutral-300 hover:bg-neutral-400"
      href={connectUrl}
      aria-label="EHA Connect"
    >
      <LogoConnect class="w-10 h-10" background-color="white" foreground-color="#999" />
    </a>
  ));
} else {
  setSuiteLogoComponent(() => (
    <div class="flex items-center ml-6 pl-3 pr-3 rounded-l-full bg-neutral-300">
      <LogoConnect class="w-10 h-10" background-color="white" foreground-color="#999" />
    </div>
  ));
}

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [{ label: "Home", name: routeNames.home }],
  },
  {
    label: "items",
    className: "",
    showLabel: false,
    items: [
      { label: "Grants", name: routeNames.grant.grants },
      { label: "Contracts", name: routeNames.contract.contracts },
      // { label: "Systems", name: routeNames.systems },
      { label: "Projects", name: routeNames.project.projects },
    ],
  },
]);
</script>
